module.exports = __webpack_public_path__ + "static/media/hamMenu.c88865f2.svg";